import { z } from 'zod'
export const workspaceSchema = z.object({
  player_id: z.string(),
  status: z.enum(['provisioning', 'ready', 'failed', 'resetting', 'stopping', 'stopped', 'suspended']),
  connected: z.boolean(),
  can_stop: z.boolean(),
  can_reset: z.boolean(),
  failure_kind: z.string().nullable(),
  provisioning_id: z.string().uuid(),
  detail: z.string(),
  wakes_on_message: z.boolean(),
})
